var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-breadcrumb',{staticClass:"app-breadcrumb",attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.breadcrumbs),function(item){return _c('el-breadcrumb-item',{key:item.path},[_c('span',{staticClass:"no-redirect"},[_vm._v(_vm._s(item.meta.title))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }